import React, { useState } from "react";
import { UpdateStyleCategory } from "../../pages";
import * as yup from "yup";
import { MimaToastUtil } from "../../components";
import { FashCreativesController } from "../../controllers";
import constant from "../../utils/constant";
import { handleImageUpload } from "../../utils/utils";

const UpdateStyleCategoryContainer = ({ closeModal, singleCategory }) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = yup.object().shape({
    categories: yup.array().of(
      yup.object().shape({
        category: yup.string().required("Category is required"),
        subCategories: yup
          .array()
          .of(yup.string().required("Subcategory is required")),

        files: yup.array().of(yup.mixed()).min(1, "Kindly add image"),
      })
    ),
  });

  const onSubmit = async (values) => {
    const mapped = values.categories.map(async (category) => {
      const file = category?.files?.[0];
      let imageUrls = [file.preview];
      if (file.name !== file.preview) {
        imageUrls = await handleImageUpload(category.files);
      }

      if (imageUrls?.length < 1 || imageUrls === constant.Failed) {
        MimaToastUtil.error({ message: "Image Upload Failed, Try again" });
      }

      return {
        category: category.category,
        subCategories: category.subCategories,
        imageUrl: imageUrls?.[0] || "",
      };
    });
    setLoading(true);

    const payload = {
      categories: await Promise.all(mapped),
    };

    const { status, errorMessage } =
      await FashCreativesController.updateStyleCategory(
        payload,
        singleCategory?._id
      );

    if (status === constant.Success) {
      MimaToastUtil.success({ message: "Style category successfully updated" });
      setLoading(false);
      return closeModal();
    } else {
      setLoading(false);
      MimaToastUtil.error({ message: errorMessage });
    }
  };

  return (
    <UpdateStyleCategory
      closeModal={closeModal}
      loading={loading}
      onSubmit={onSubmit}
      validationSchema={validationSchema}
      singleCategory={singleCategory}
    />
  );
};

export default UpdateStyleCategoryContainer;
